import request from '@/utils/request';
import { LoginParamsType } from './data.d';

export async function accountLogin(params: LoginParamsType): Promise<any> {
  return request({
    url: '/dieeu/bu/user/loginByUserName',
    method: 'POST',
    timeout: 15000,
    data: params,
  });
}

/** 根据 token 获取当前登录的 adminUser 信息 */
export async function getAdminUser(): Promise<any> {
  return request({
    url: '/dieeu/bu/user/getAdminUser',
    method: 'GET',
    timeout: 15000,
  });
}
